import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {BackToTop, IconImage, ButtonTextContainer} from './styles'

const BackToTopButton = () => {
  const {t} = useTranslation('common')
  // The back-to-top button is hidden at the beginning
  const [showButton, setShowButton] = useState(false)

  const handleScroll = () => setShowButton(window.pageYOffset > 30)

  const scrollToTop = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    showButton && (
      <BackToTop aria-label={t('backToTop.ariaMessage')} onClick={scrollToTop}>
        <ButtonTextContainer>
          <IconImage />
          {t('backToTop.text')}
        </ButtonTextContainer>
      </BackToTop>
    )
  )
}

export default BackToTopButton
